import h from 'hyperscript';

import 'ui/autosize-textarea/autosize-textarea';

import type { WorkbookVersionDto } from 'cadenza/api-client/dto/workbook-version-dto';
import { renderWorkbookVersionCell } from 'cadenza/workbook-version/workbook-version-cell-renderer';

import i18n from './workbook-metadata-form.properties';

const COMPONENT_NAME = 'd-workbook-metadata-form';
export class WorkbookMetadataForm extends HTMLElement {
  #commentInput;

  constructor(version: WorkbookVersionDto) {
    super();
    this.classList.add(COMPONENT_NAME, 'd-stack-v', 'space-2');
    this.append(
      renderWorkbookVersionCell(version),
      h(
        'form-group',
        h('label', i18n('comment.label')),
        h(
          'd-autosize-textarea',
          (this.#commentInput = h<HTMLTextAreaElement>('textarea', { maxLength: 255 }, version.comment)),
        ),
      ),
    );
  }

  get comment() {
    return this.#commentInput.value;
  }
}

customElements.define(COMPONENT_NAME, WorkbookMetadataForm);
